import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import App from "./App";
import "./assets/styles/fc-styles.css";
import "./assets/styles/fui-styles.css";
import "./assets/styles/index.css";
import OnBoardingContextProvider from "./components/onBoarding/OnBoardingContextProvider";
import { persistor, store } from "./redux/store";
import reportWebVitals from "./reportWebVitals";

// ===================== ResizeObserver Error Handler =====================
// ===================== Global Script Error Handler =====================
window.onerror = function (message) {
  if (message === "Script error.") {
    window.location.reload();
    return true;
  }
};
const observerErrorHandler = (event) => {
  // Check if the error message includes "ResizeObserver loop"
  if (event.message && event.message.includes("ResizeObserver loop")) {
    // Ignore the ResizeObserver loop error
    return;
  }
  console.error(event);
};

window.addEventListener("error", observerErrorHandler);
window.addEventListener("unhandledrejection", (event) => {
  if (event.reason?.message?.includes("ResizeObserver loop")) {
    // Prevent unhandled promise rejections for ResizeObserver errors
    event.preventDefault();
  }
});
// =======================================================================

if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/firebase-messaging-sw.js?v=" + Date.now())
    .then(async (registration) => {
      console.log("Service Worker registered with scope:", registration.scope);
      // Force update to get latest service worker in development
      await registration.update();
      console.log("[index.js] Service worker update check completed");
    })
    .catch((err) => {
      console.error("Service Worker registration failed:", err);
    });
} else {
  console.warn("Service Worker is not supported in this browser.");
}

// Initialize Microsoft Clarity (static import per official documentation)
import clarity from "@microsoft/clarity";
const CLARITY_PROJECT_ID = process.env.REACT_APP_CLARITY_PROJECT_ID;
if (typeof window !== "undefined" && CLARITY_PROJECT_ID) {
  clarity.init(CLARITY_PROJECT_ID);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <OnBoardingContextProvider>
        <App />
      </OnBoardingContextProvider>
    </PersistGate>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
